export default __webpack_public_path__ + "static/media/CARE_DASH.bf6eebdc.png";